import SvgIcon from '../../elements/SvgIcon';
import { OtherUserTooltipProps } from '../../../types';

const OtherUserTolltip: React.FC<OtherUserTooltipProps> = ({
  users,
  maxVisible,
  remainingCount,
}) => {
  return (
    <div className="relative group">
      <div className="w-10 h-10 rounded-full cursor-pointer border-2 bg-[#1F2937] flex items-center justify-center text-white hover:bg-[#1F2937]/80 transition-colors duration-200">
        <SvgIcon iconType="user" />
        <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
          +{remainingCount}
        </span>
      </div>

      {/* Tooltip for remaining users */}
      <div className="absolute bottom-full h-32 overflow-y-auto left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap">
        <div className="flex flex-col gap-1">
          {users.slice(maxVisible).map((user) => (
            <div key={user.id} className="flex items-center space-x-2">
              <span className="bg-green-700 w-2 h-2 rounded-full" />
              <span>{user.name}</span>
            </div>
          ))}
        </div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-900" />
      </div>
    </div>
  );
};

export default OtherUserTolltip;
